import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Observable} from 'rxjs/Observable';
import {} from '../pages/layout/list-scooters/list-scooters.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { LatLong } from '../pages/maps/gmaps/gmaps.component';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MapsService {

  constructor(private afs: AngularFirestore) { }

  getMapsData(){
    return this.afs.doc('/devices/867322033678137').snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as LatLong;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  }

  addGeofence(coordinates) {
    this.afs.doc(environment.env.EnvBaseUrl+'/'+environment.env.GeofenceCollection+'/I89wSc4xETUA3PNjrxcP').update({'coordinates':coordinates});
  }

  editGeofence(coordinates) {
    this.afs.doc(environment.env.EnvBaseUrl+'/'+environment.env.GeofenceCollection+'/I89wSc4xETUA3PNjrxcP').set({'coordinates':coordinates});
  }

  deleteGeofence() {
    this.afs.doc(environment.env.EnvBaseUrl+'/'+environment.env.GeofenceCollection+'/I89wSc4xETUA3PNjrxcP').set({'coordinates':[]});
  }

  getGeofenceData() {
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+environment.env.GeofenceCollection+'/I89wSc4xETUA3PNjrxcP').snapshotChanges().pipe(map(action => {
      const data = action.payload.data() as LatLong;
      const id = action.payload.id;
      return { id, ...data };
    }));
  }

}